import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { Button, Dialog } from "@mui/material";
import EstablishmentSelectionModal from "common/components/AuthFormDialog/components/EstablishmentSelectionModal";
import { ApiService } from "common/services/ApiService";
import { useAuth } from "context/AuthContext";
import queryString from "query-string";
import { PENDING_NOTIFICATION_MAP } from "utils/constants";
import AuthFormDialog from "../AuthFormDialog/AuthFormDialog";
import LoggedUserMenu from "./components/LoggedUserMenu";
import LoggedUserMenuMobile from "./components/LoggedUserMenuMobile";
import LogoutConfirmationDialog from "./components/LogoutConfirmationDialog";
import NotLoggedUserMenu from "./components/NotLoggedUserMenu";
import useStyles, { stylesSx } from "./styles";
import {
    adminSettings,
    superAdminSettings,
    teacherSettings,
    userSettings,
} from "./utils/constants";

export default function NavBar({ handleDrawerToggle }) {
    const { auth, setAuth } = useAuth();
    const [settings, setSettings] = useState([]);
    const [open, setOpen] = useState(false);
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [openLogInForm, setOpenLogInForm] = useState(false);
    const [openSignInForm, setOpenSignInForm] = useState(false);
    const [pendingNotificationIntervalId, setPendingNotificationIntervalId] = useState();
    const [pendingNotification, setPendingNotification] = useState({});
    const [openEstablishmentModal, setOpenEstablishmentModal] = useState(false);

    const [loggedByGoogle, setLoggedByGoogle] = useState(false);
    const [roleSelected, setRoleSelected] = useState(null);

    const [anchorElements, setAnchorElements] = useState([
        { name: "datasets", value: null },
        { name: "grafos", value: null },
        { name: "establishments", value: null },
        { name: "roles", value: null },
    ]);
    const [dataGoogle, setDataGoogle] = useState({});

    const { boxFlexStyle, appBarStyle, menuButtons } = stylesSx;

    const location = useLocation();
    const queryParams = queryString.parse(location.search);

    useEffect(() => {
        if (queryParams.authError) {
            setOpenLogInForm(true);
        }
    }, [location]);

    const classes = useStyles();

    const handleOpenNavMenu = (event) => {
        if (anchorElNav === null) {
            setAnchorElNav(event.currentTarget);
        } else {
            setAnchorElNav(null);
        }
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleOpenMenu = (event, menuName) => {
        const element = anchorElements.find((objeto) => objeto.name === menuName);

        if (element) {
            element.value = event.currentTarget;
            setAnchorElements([...anchorElements]);
        }
    };
    const handleCloseMenu = (menuName) => {
        const element = anchorElements.find((objeto) => objeto.name === menuName);

        if (element) {
            element.value = null;
            setAnchorElements([...anchorElements]);
        }
    };

    const getConfigurationAuthMe = async (access) => {
        localStorage.setItem("access", access);
        const dataUser = await ApiService.me(access);
        const pendingNotification = {};

        if (dataUser.status === 200) {
            localStorage.setItem(
                "rolesEstablishment",
                JSON.stringify(dataUser.data.role_establishment_list)
            );
            localStorage.setItem("userName", dataUser.data.first_name);
            localStorage.setItem("userId", dataUser.data.id);

            let selectedRole = null;
            if (dataUser.data.roles.includes(4)) {
                selectedRole = { name: "superadmin" };
            }

            localStorage.setItem("selectedRole", JSON.stringify(selectedRole));
            localStorage.setItem("pendingNotification", JSON.stringify(pendingNotification));

            setAuth({
                access,
                rolesEstablishment: dataUser.data.role_establishment_list,
                userName: dataUser.data.firstName,
                selectedRole: selectedRole,
                pendingNotification,
                userId: dataUser.data.id,
            });
            return dataUser;
        }
        return;
    };

    const afterCompleteRegisterGoogle = () => {
        const { access_token, new_user, roles_pending, complete_data } = dataGoogle;
        if (access_token) {
            if (new_user === true) {
                localStorage.setItem("access", access_token);
                localStorage.setItem("rolesEstablishment", JSON.stringify([]));
                setAuth({
                    ...auth,
                    access: access_token,
                    rolesEstablishment: [],
                });
            } else {
                if (roles_pending === false && complete_data === false) {
                    localStorage.setItem("access", access_token);
                    localStorage.setItem("rolesEstablishment", JSON.stringify([]));
                    setAuth({
                        ...auth,
                        access: access_token,
                        rolesEstablishment: [],
                    });
                    setDataGoogle({});
                    return;
                }
                setDataGoogle({});
                getConfigurationAuthMe(access_token);
            }
            setDataGoogle({});
        }
    };

    const setConfigurationGoogle = (data) => {
        const { access_token, new_user, roles_pending, complete_data } = data;
        setDataGoogle(data);
        if (access_token) {
            setLoggedByGoogle(true);
            setOpenLogInForm(false);
            if (new_user === true) {
                setOpenSignInForm(true);
            } else {
                if (roles_pending === false && complete_data === false) {
                    setOpenSignInForm(true);
                    return;
                }
                getConfigurationAuthMe(access_token);
                setOpenEstablishmentModal(true);
                setOpenSignInForm(false);
            }
        }
    };

    useEffect(() => {
        const setMenuSettings = () => {
            if (auth.rolesEstablishment !== undefined && auth.rolesEstablishment.length > 0) {
                let selectedRole = JSON.parse(localStorage.getItem("selectedRole"));
                if (selectedRole) {
                    if (selectedRole.name === "admin") {
                        setSettings(adminSettings);
                    } else if (selectedRole.name === "teacher") {
                        setSettings(teacherSettings);
                    } else if (selectedRole.name === "superadmin") {
                        setSettings(superAdminSettings);
                    }
                    return;
                }
            }
            setSettings(userSettings);
        };
        setMenuSettings();
    }, [auth.rolesEstablishment, auth.selectedRole]);

    useEffect(() => {
        if (auth?.selectedRole) {
            checkPendingNotification(auth?.selectedRole?.name);
        }
    }, []);

    const checkPendingNotification = async (role, authUpdated = {}) => {
        const res = await ApiService.pendingNotification({
            category: PENDING_NOTIFICATION_MAP[role]?.join(","),
            read: false,
            establishment: role === "superadmin" ? null : auth?.selectedEstablishment?.id,
            joined_courses: ["superadmin", "admin"].includes(role) ? false : true,
            role_name: role,
        });

        let pendingNotification = {};

        if (PENDING_NOTIFICATION_MAP[role]) {
            pendingNotification = PENDING_NOTIFICATION_MAP[role]?.reduce((acc, category) => {
                acc[category] = res.data.some((item) => item.category === category);
                return acc;
            }, {});
        }

        setAuth({
            ...auth,
            ...authUpdated,
            pendingNotification,
        });

        setPendingNotification(pendingNotification);
        localStorage.setItem("pendingNotification", JSON.stringify(pendingNotification));
        return pendingNotification;
    };

    return (
        <Box sx={boxFlexStyle}>
            <AppBar position="fixed" sx={appBarStyle}>
                <Toolbar
                    sx={{
                        minHeight: {
                            md: 80,
                            xs: 80,
                        },
                    }}
                >
                    <Box style={{ display: "flex" }}>
                        <Typography
                            variant="p"
                            noWrap
                            component="div"
                            sx={{
                                mr: 2,
                                fontFamily: "monospace",
                                fontWeight: 700,
                                letterSpacing: ".3rem",
                                color: "inherit",
                                textDecoration: "none",
                            }}
                        >
                            <Link to="/" className={classes.linkNavBar}>
                                <img src="/img/logoAd.png?v=2" alt="logo1" className={classes.logo} />
                            </Link>
                        </Typography>
                        <Button
                            sx={menuButtons}
                            onClick={() =>
                                window.open(
                                    "https://alfadatizandoinfo.wordpress.com/",
                                    "_blank",
                                    "noopener,noreferrer"
                                )
                            }
                        >
                            + Info
                        </Button>
                    </Box>
                    {auth !== "" &&
                        ["/teacher", "/superadmin", "/admin"].includes(location.pathname) && (
                            <LoggedUserMenuMobile
                                anchorElNav={anchorElNav}
                                handleOpenNavMenu={handleDrawerToggle}
                                handleCloseNavMenu={handleCloseNavMenu}
                                handleOpenMenu={handleOpenMenu}
                                handleCloseMenu={handleCloseMenu}
                                anchorElements={anchorElements}
                                setOpen={setOpen}
                                settings={settings}
                                setSettings={setSettings}
                            />
                        )}
                    {/* <Typography
                        variant="p"
                        noWrap
                        component="div"
                        sx={{
                            mr: 2,
                            display: { xs: "flex", md: "none" },
                            flexGrow: 1,
                            fontFamily: "monospace",
                            fontWeight: 700,
                            letterSpacing: ".3rem",
                            color: "inherit",
                            textDecoration: "none",
                        }}
                    >
                        <Link to="/" className={classes.linkNavBar}>
                            <img
                                src="/img/logoAd.png?v=2"
                                alt="logo"
                                className={classes.logo}
                            />
                        </Link>
                    </Typography> */}
                    {auth !== "" ? (
                        <LoggedUserMenu
                            anchorElements={anchorElements}
                            setAnchorElements={setAnchorElements}
                            handleCloseMenu={handleCloseMenu}
                            handleOpenMenu={handleOpenMenu}
                            setOpen={setOpen}
                            userName={auth.userName}
                            settings={settings}
                            setSettings={setSettings}
                            checkPendingNotification={checkPendingNotification}
                            pendingNotificationIntervalId={pendingNotificationIntervalId}
                            setPendingNotificationIntervalId={setPendingNotificationIntervalId}
                            pendingNotification={pendingNotification}
                            roleSelectedDefault={roleSelected}
                        />
                    ) : (
                        <NotLoggedUserMenu
                            setOpenLogInForm={setOpenLogInForm}
                            setOpenSignInForm={setOpenSignInForm}
                        />
                    )}
                </Toolbar>
            </AppBar>

            <AuthFormDialog
                getConfigurationAuthMe={(access) => getConfigurationAuthMe(access)}
                type={"login"}
                open={openLogInForm}
                setOpen={setOpenLogInForm}
                handleChangeForms={() => {
                    setOpenLogInForm(false);
                    setOpenSignInForm(true);
                }}
                checkPendingNotification={checkPendingNotification}
                pendingNotificationIntervalId={pendingNotificationIntervalId}
                setPendingNotificationIntervalId={setPendingNotificationIntervalId}
                loggedByGoogle={loggedByGoogle}
                setConfigurationGoogle={setConfigurationGoogle}
                setRoleSelectedCallback={(value) => setRoleSelected(value)}
                afterCompleteRegisterGoogle={afterCompleteRegisterGoogle}
                dataGoogle={dataGoogle}
            />
            <AuthFormDialog
                getConfigurationAuthMe={(access) => getConfigurationAuthMe(access)}
                type={"signin"}
                open={openSignInForm}
                setOpen={setOpenSignInForm}
                handleChangeForms={() => {
                    setOpenSignInForm(false);
                    setOpenLogInForm(true);
                }}
                checkPendingNotification={checkPendingNotification}
                pendingNotificationIntervalId={pendingNotificationIntervalId}
                setPendingNotificationIntervalId={setPendingNotificationIntervalId}
                loggedByGoogle={loggedByGoogle}
                setConfigurationGoogle={setConfigurationGoogle}
                setRoleSelectedCallback={(value) => setRoleSelected(value)}
                afterCompleteRegisterGoogle={afterCompleteRegisterGoogle}
                dataGoogle={dataGoogle}
            />

            <LogoutConfirmationDialog
                setLoggedByGoogle={setLoggedByGoogle}
                setAuth={setAuth}
                setOpen={setOpen}
                open={open}
                pendingNotificationIntervalId={pendingNotificationIntervalId}
                setRoleSelectedCallback={() => setRoleSelected(null)}
            />

            {openEstablishmentModal && (
                <Dialog
                    open={openEstablishmentModal}
                    // ESTE ONCLOSE NO VA
                    onClose={() => setOpenEstablishmentModal(false)}
                >
                    <EstablishmentSelectionModal
                        setOpen={setOpenEstablishmentModal}
                        checkPendingNotification={checkPendingNotification}
                        pendingNotificationIntervalId={pendingNotificationIntervalId}
                        setPendingNotificationIntervalId={setPendingNotificationIntervalId}
                        setRoleSelectedCallback={(value) => setRoleSelected(value)}
                    ></EstablishmentSelectionModal>
                </Dialog>
            )}
        </Box>
    );
}
